import React from "react";

import HeroSection from "components/hero-section";
import { sendAnalyticEvent } from "components/layout/page/use-page";

import { sectionIds } from "./section-ids";

const anchors = [
  { title: "Why Residential Solar Companies Need an OS", id: sectionIds.grewFast },
  { title: "How Enerflo’s OS Works", id: sectionIds.howOsWorks },
  { title: "Enerflo’s OS Features & Capabilities", id: sectionIds.features },
  { title: "Residential Solar Industry Solutions", id: sectionIds.solutions },
];

const JumpTo = () => (
  <div className="bg-gray-100">
    <HeroSection className="sm:py-6 lg:py-6">
      <HeroSection.Content className="text-gray-600 text-sm flex flex-col justify-center gap-x-8 gap-y-4 px-4 lg:px-4 xl:items-center xl:flex-row">
        <p className="text-center font-bold uppercase tracking-wide whitespace-nowrap">Jump to</p>
        <div className="flex gap-3 flex-wrap items-center justify-center">
          {anchors.map(anchor => (
            <a
              key={anchor.id}
              href={`#${anchor.id}`}
              className="rounded-full shadow !px-4 !py-1.5 btn btn-white sm:shrink-0"
              onClick={() => sendAnalyticEvent("Engagement Button", "Buttons", `Jump to ${anchor.title}`)}
            >
              {anchor.title}
            </a>
          ))}
        </div>
      </HeroSection.Content>
    </HeroSection>
  </div>
);

export default JumpTo;
